import { SignInState } from './types'

export const state: SignInState = {
  loading: false,
  username: 'Javier Licea',
  type: 'Admin',
  content: {},
  deviceId: 0
}
